import { useOutletContext, useParams } from "react-router-dom";
import BaseLayout from "../../layouts/BaseLayout";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import IntakeDemos from "./PageIntake/IntakeDemos";
import CommentsList from "../../components/CommentsList";

export default function PageIntake() {
  const { id: intakeId } = useParams();
  const { api } = useOutletContext();

  return (
    <BaseLayout>
      <Stack spacing={2}>
        <IntakeDemos intakeId={intakeId} />
        <Card>
          <CardHeader title="Comments" />
          <CardContent sx={{ py: 0 }}>
            <CommentsList api={api} entity="intake" ident={intakeId} />
          </CardContent>
        </Card>
      </Stack>
    </BaseLayout>
  );
}
